import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Message, Loader, Modal, Flex, Box, Button, Text } from "samba-ui";
import { checkPermissionDelete } from "../api";

const DeletePermissionModal = ({
  id,
  name,
  isOpen,
  onClose,
  onDelete,
  isDefault
}) => {
  const [loading, setLoading] = useState(false);
  const [deleteable, setDeleteable] = useState(null);
  useEffect(() => {
    // check if this filter can be deleted?
    // TODO: Add error state
    const req = async () => {
      const res = await checkPermissionDelete(id);
      const { data } = await res.json();
      setDeleteable(data);
      setLoading(false);
    };
    if (!isDefault) {
      req();
    } else {
      setDeleteable(false);
    }

    setLoading(true);
  }, [id, isDefault]);

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose}>
      {loading || deleteable == null ? (
        <Box textAlign="center" width="100%">
          <Loader />
        </Box>
      ) : (
        <>
          <Modal.Header borderColor="#d6d6d6 !important">
            Delete {name} Permission
          </Modal.Header>
          <Modal.Content>
            {!deleteable ? (
              <Message mb={2} variant="alert">
                This permission is currently being used by other users. You can
                not delete! If you would like to delete the permission, you will
                need to go and remove this permission from user's dashboard
              </Message>
            ) : (
              <Text color="palette.ink.600">
                This permission will no longer available. Are you sure you want
                to delete?
              </Text>
            )}
          </Modal.Content>
          <Modal.Actions
            justifyContent="flex-end"
            borderColor="#d6d6d6 !important"
          >
            <Flex>
              <Box mr={3}>
                <Button variant="secondary" onClick={onClose}>
                  Cancel
                </Button>
              </Box>
              <Button
                variant="destructive"
                onClick={() => onDelete(id)}
                disabled={!deleteable}
              >
                Delete
              </Button>
            </Flex>
          </Modal.Actions>
        </>
      )}
    </Modal>
  );
};

DeletePermissionModal.propTypes = {
  name: PropTypes.string,
  id: PropTypes.number.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isDefault: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func
};

export default DeletePermissionModal;
